<template>
  <div>
    <div style="margin-bottom:50px ">
      <span>产品：</span>
      <v-select style="width: 220px;margin-right: 20px"
                :data="appOptions"
                placeholder="选择产品组"
                :allowClear="false"
                v-model="appValue"></v-select>
      <span>时间：</span>
      <v-date-picker range
                     placeholder="请选择时间段"
                     style="width:270px;margin-right: 20px"
                     v-model="rangeDate"
                     clearable></v-date-picker>
      <span>状态：</span>
      <v-select style="width: 220px;"
                :data="stateOptions"
                placeholder="选择回复状态"
                v-model="stateValue"></v-select>
      <v-button type="primary"
                @click="search">筛选</v-button>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="id"
                       label="反馈编号">
      </el-table-column>
      <el-table-column prop="create_time"
                       label="创建时间">
      </el-table-column>
      <el-table-column prop="order_id"
                       label="反馈订单号">
      </el-table-column>
      <el-table-column prop="content" label="反馈描述">
      </el-table-column>
      <el-table-column label="反馈详情">
        <template slot-scope="scope">
          <el-button type="text"
                     @click="goDetail(scope.row)"
                     size="small">更多</el-button>

        </template>
      </el-table-column>
      <el-table-column label="反馈图片">
        <template slot-scope="scope">
          <el-button v-if="scope.row.feedback_image_url" type="text"
                     :key="index"
                     v-for="(item,index) in scope.row.feedback_image_url"
                     @click="showImage(item)"
                     size="small">{{`图片${index+1}`}}</el-button>

        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button v-if="scope.row.need_reply" type="text"
                     @click="goReply(scope.row)"
                     size="small">{{scope.row.replied ? '修改回复' : '点击回复'}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="total, prev, pager, next"
      style="float: right"
      :total="total"
      :current-page="page+1"
      :page-size="5"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <v-modal title="反馈详情"
             :width=650
             :visible="detailVisible"
             @cancel="detailVisible=false">
      <div style="margin: 10px;display: flex">
        <p style="width:86px;">用户ID</p>
        <p style="width:300px">{{detail.user_id}}</p>
        <p style="width:100px;">系统版本号</p>
        <p>{{detail.system_version}}</p>
      </div>
      <div style="margin: 10px;display: flex">
        <p style="width:86px;">反馈类型</p>
        <p style="width:300px">{{detail.feedback_reasons && detail.feedback_reasons.join('/')}}</p>
        <p style="width:100px;">客户端系统</p>
        <p>{{detail.device_model}}</p>
      </div>
      <div style="margin: 10px;display: flex">
        <p style="width:86px;">联系方式</p>
        <p style="width:300px">{{detail.user_contact}}</p>
        <p style="width:100px;">软件版本号</p>
        <p>{{detail.software_version}}</p>
      </div>
      <div slot="footer">
        <v-button type="primary" @click="detailVisible=false">
          关闭
        </v-button>
      </div>
    </v-modal>
    <v-modal title="图片预览"
             :width=400
             :visible="previewPicVisible"
             @cancel="previewPicVisible=false">
      <div class="pic-preview" :style="{backgroundImage:'url('+previewPic+')', display:'flex'}"></div>
      <div slot="footer">
        <v-button type="primary" @click="previewPicVisible=false">
          关闭
        </v-button>
      </div>
    </v-modal>
    <v-modal title="回复"
             :width=600
             :visible="replyVisible"
             @ok="handleReply"
             @cancel="replyVisible=false">
      <div style="margin: 10px 20px;display: flex">
        <p style="width:100px;">反馈编号</p>
        <p style="width:300px">{{detail.id}}</p>
      </div>
      <div style="margin: 10px 20px;display: flex">
        <p style="width:100px;">反馈订单号</p>
        <p>{{detail.order_id}}</p>
      </div>
      <div style="margin: 10px 20px;display: flex">
        <p style="width:100px;">反馈类型</p>
        <p>{{detail.feedback_reasons && detail.feedback_reasons.join('/')}}</p>
      </div>
      <div style="margin: 10px 20px;display: flex">
        <p style="width:100px;">内容回复</p>
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4}"
          placeholder="请输入回复内容"
          v-model="reply">
        </el-input>
      </div>
    </v-modal>
  </div>
</template>

<script>
import axios from 'axios'
// 200806145681206001j cff27be6c59c11ea9a8100163e009f55
export default {
  data () {
    return {
      appOptions: [],
      stateOptions: [{value: 'replied', label: '已回复'}, {value: 'no_replied', label: '未回复'}],
      appValue: '',
      stateValue: '',
      rangeDate: ['', ''],
      tableData: [],
      page: 0,
      limit: 5,
      detailVisible: false,
      detail: {},
      previewPic: '',
      previewPicVisible: false,
      replyVisible: false,
      reply: '',
      total: 0
    }
  },
  methods: {
    getApps () {
      axios.get('/dev/package_info').then(res => {
        let arr = []
        res.data.package_info.forEach(item => {
          let obj = {}
          obj.value = item.value
          obj.label = item.key
          arr.push(obj)
        })
        this.appOptions = arr
      })
    },
    showImage (item) {
      this.previewPic = item
      this.previewPicVisible = true
    },
    goReply (data) {
      this.detail = data
      this.reply = data.replied_content && data.replied_content
      this.replyVisible = true
    },
    handleSearch () {
      this.page = 0
      this.search()
    },
    handleCurrentChange (val) {
      this.page = val - 1
      this.search()
    },
    search () {
      let startTime, endTime, appValue
      startTime = this.rangeDate[0]
      endTime = this.rangeDate[1]
      appValue = this.appValue
      let url = '/dev/feedback'
      url = url + '?app_key=' + appValue + '&state=' + this.stateValue + '&start_time=' + startTime + '&end_time=' + endTime + '&page=' + this.page + '&limit=' + this.limit
      axios.get(url)
        .then(res => {
          this.tableData = res.data.feedbacks.map(item => {
            // eslint-disable-next-line
            return {...item, need_reply: res.data.need_reply === false ? false : true}
          })
          this.total = res.data.total
        })
    },
    goDetail (data) {
      this.detail = data
      this.detailVisible = true
    },
    handleReply () {
      axios.post(`/dev/feedback/${this.detail.id}/reply`, { replied_content: this.reply })
        .then(res => {
          this.search()
          this.replyVisible = false
        })
    }
  },
  created () {
    this.getApps()
  }
}
</script>

<style scoped>
  .pic-preview{
    width: 380px;height: 380px;
    background-size: contain;background-repeat: no-repeat;
    background-position: center
  }
</style>



// WEBPACK FOOTER //
// src/pages/workSheet/workSheet.vue